
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ophthalmology",
      function () {
        return require("private-next-pages/ophthalmology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ophthalmology"])
      });
    }
  